import { IIconProps } from '../../types/IconProps.interface'

export const IconTelegram = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 19 16'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18.402 1.40896L15.6171 14.5425C15.4069 15.4694 14.859 15.7001 14.0804 15.2635L9.83713 12.1366L7.78965 14.1058C7.56307 14.3324 7.37356 14.5219 6.93687 14.5219L7.24173 10.2004L15.1062 3.09391C15.4481 2.78905 15.0321 2.62014 14.5748 2.925L4.85232 9.04685L0.666715 7.73679C-0.243735 7.45253 -0.260214 6.82634 0.856221 6.38966L17.2278 0.0824198C17.9859 -0.201838 18.6491 0.251327 18.402 1.40896Z'
        fill={color}
      />
    </svg>
  )
}
